import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

import { Button, InputBase } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';

import useStyles from './styles';

interface Props {
    value: MayBeNil<string>;
    onChange: (value: MayBeNil<string>) => void;
    className?: string;
    placeholder?: string;
}

const SearchInput: React.FC<Props> = ({ value, onChange, className, placeholder }) => {
    const { classes, cx } = useStyles();

    const normalize = useCallback((value: MayBeNil<string>) => (value ? value.trim().replace(/\s{2,}/g, '') : ''), []);

    const [internalValue, setInternalValue] = useState(() => normalize(value));
    useEffect(() => setInternalValue(normalize(value)), [normalize, value]);

    const handleInputChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => setInternalValue(event.target.value),
        []
    );
    const handleInputKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                if (event.target instanceof HTMLInputElement) {
                    onChange(normalize(event.target.value));
                }
            }
        },
        [normalize, onChange]
    );

    return (
        <div className={cx(classes.root, className)}>
            <InputBase
                value={internalValue}
                placeholder={placeholder}
                onChange={handleInputChange}
                onKeyDown={handleInputKeyDown}
                className={classes.input}
            />
            <Button
                variant="contained"
                disableElevation
                onClick={() => onChange(normalize(internalValue))}
                disabled={isEmpty(internalValue)}
                className={classes.button}
            >
                {'Search'}
            </Button>
        </div>
    );
};

export default SearchInput;
